import React from "react";

// FigureWithProvenance (Block Two item 13). Three render states so the person who releases
// a figure can see what they are vouching for. A figure with NO provenance renders as
// "source unknown" — never a bare number — so a missing stamp fails loud.
//
// Usage: <FigureWithProvenance figure={{ value: "₦5.2m", provenance: {...} }} />
//   provenance.state: "good" | "stale" | "unknown"

const STYLE = {
  good: { dot: "bg-emerald-500", text: "text-slate-900", label: (p) =>
    p.rate_card_version
      ? `rate card ${p.rate_card_version}${p.effective_date ? ` · effective ${fmt(p.effective_date)}` : ""}`
      : `${p.source || "recorded"}${p.recorded_at ? ` · as of ${fmt(p.recorded_at)}` : ""}` },
  stale: { dot: "bg-amber-500", text: "text-amber-700", label: (p) =>
    p.is_inferred ? "inferred — confirm before sending" : `stale · last known ${fmt(p.recorded_at)}` },
  unknown: { dot: "bg-red-500", text: "text-red-600", label: () => "source unknown — do not send unchecked" },
};

function fmt(iso) {
  if (!iso) return "unknown date";
  const d = new Date(iso);
  return isNaN(d) ? "unknown date" : d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

export default function FigureWithProvenance({ figure, className = "" }) {
  // A missing figure or missing provenance => unknown (fails loud).
  const value = figure && "value" in figure ? figure.value : figure;
  const prov = (figure && figure.provenance) || { state: "unknown" };
  const state = prov.state || "unknown";
  const s = STYLE[state] || STYLE.unknown;
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`} data-testid="figure-provenance"
          data-provenance-state={state} title={s.label(prov)}>
      <span className={`font-medium ${s.text}`} data-testid="figure-value">
        {value === null || value === undefined || value === "" ? "—" : value}
      </span>
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} aria-hidden />
      <span className="text-[11px] text-slate-400" data-testid="figure-provenance-label">{s.label(prov)}</span>
    </span>
  );
}
